import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('LigneAnnuaireDA', LigneAnnuaireDA);

    LigneAnnuaireDA.$inject = ['Restangular', 'CONF'];

    /* @ngInject */
    function LigneAnnuaireDA(Restangular, CONF) {
        var baseUrl = CONF.apiBaseUrl + '/v1/pdpcheck';

        var exports = {
            checkPdpConflict: checkPdpConflict
        };

        return exports;

        function checkPdpConflict(entityType, entityId, startDate, endDate) {
            return Restangular
                .one(baseUrl, 'checkPdpConflict')
                .one(entityType, entityId)
                .get({ startDate, endDate })
                .then(response => {
                    return response;
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        }
    }
})();
